import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Tabs} from '@phonectas/unifon-ui-kit';
import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {shallow} from 'zustand/shallow';

interface CustomerTabsNavProps {
	activeTab: string;
	setActiveTab: (value: string) => void;
}

const CustomerTabsNav: React.FC<CustomerTabsNavProps> = ({activeTab, setActiveTab}) => {
	const [t] = useTranslation();
	const {totalCount} = useThreeSixtyNewStore((state) => ({
		totalCount: state.accountTables?.visma?.invoices.length,
	}), shallow);

	const tabs = useMemo(() => [
		{value: '1', label: t('Users').toUpperCase()},
		{value: '2', label: t('Billing group').toUpperCase()},
		{value: '3', label: t('Contacts').toUpperCase()},
		{value: '4', label: `${t('Open records').toUpperCase()} ${totalCount ? `(${totalCount})` : ''} `},
		{value: '5', label: t('Zendesk').toUpperCase()},
		// {value: '6', label: t('Bedriftsnett').toUpperCase()},
		// {value: '7', label: t('Config / Forms').toUpperCase()},
	], [t, totalCount]);

	return (
		<Tabs
			items={tabs}
			active={activeTab}
			onChange={(value) => setActiveTab(String(value))}
		/>
	);
}

export default CustomerTabsNav;
